import videojs from 'video.js';
import Tools from '../services/tools';
import vjsSrv from '../services/vjsSrv';
import eventsSrv from '../services/events';
import Config from '../services/config';
import { PMWrap } from '../services/PMWrap';
import { PLAYER_EVENTS } from 'vimmi-web-utils/cjs/postMessage';

export class PrevNextButtonService {
  constructor() {
    this.assets = {
      NextButton: {},
      PrevButton: {},
    };
  }

  handleClick(componentName, options) {
    if (this.assets[componentName]) {
      this.assets[componentName].playerOptions.autoplay = true;

      setTimeout(() => {
        eventsSrv.emit('_internal-play', {
          asset: this.assets[componentName],
          isFullAsset: this.assets[componentName].get('playerOptions.loadMode') !== 'lite',
        });
        if (!Config.get('params.imported')) {
          PMWrap.inst().sendWrappedEvent(options.pmEvent, Tools.copy(this.assets[componentName]));
        }
        eventsSrv.emit(options.pmEvent, Tools.copy(this.assets[componentName]));
        this.disable(componentName);
      }, 100);
    }
  }

  isActive(componentName) {
    return !!this.assets[componentName] && !!this.assets[componentName].playerOptions;
  }

  show(componentName) {
    this.getComponent(componentName)
      .show();
  }

  hide(componentName) {
    this.getComponent(componentName)
      .hide();
  }

  disable(componentName) {
    this.assets[componentName] = null;
    this.getComponent(componentName)
      .disable();
  }

  enable(componentName) {
    this.getComponent(componentName)
      .enable();
  }

  setAsset(componentName, asset) {
    this.assets[componentName] = asset;
    this._updateComponent(componentName, asset);
  }

  _updateComponent(componentName, asset) {
    this.getComponent(componentName)
      .controlText(asset.get('extraData.title'));
  }

  getComponent(componentName) {
    let comp = vjsSrv.vjsPlayer.getChild('controlBar')
      .getChild(componentName);
    if (!comp) {
      let isNext = componentName === 'NextButton';
      let controlBar = vjsSrv.vjsPlayer.getChild('controlBar');

      let firstChild = controlBar.children_[0];
      let index = firstChild.name_ === 'PlayToggle' ? 1 : 2;
      comp = controlBar.addChild(componentName, {}, isNext ? index : 0);
    }
    return comp;
  }
}

// const _PrevNextButtonSrv = new PrevNextButtonService();
function register(componentName, options) {
  options = options || {
    elClass: 'vjs-play-next-btn',
    pmEvent: null,
  };
  // PrevNextButtonService.prototype.options = PrevNextButtonService.prototype.options || {};
  // PrevNextButtonService.prototype.options[componentName] = options;
  let Button = videojs.getComponent('Button');
  let newButton = videojs.extend(Button, {
    constructor: function() {
      Button.apply(this, arguments);
      this.hide();
      this.disable();
      this.addClass(options.elClass);
      let iconHolder = this.el().querySelector('.vjs-icon-placeholder');

      // if (Config.get('params.style_schema') === 'lg-ais') {
      //   iconHolder.innerHTML = componentName === 'NextButton' ? 'Next episode <span class="icon-right"></span>' : '<span class="icon-left"></span> Prev episode';
      // } else {
      iconHolder.classList.add(componentName === 'NextButton' ? 'icon-right-open' : 'icon-left-open');
      // }
      this.on(['click', 'tap'], () => {
        // if (Config.get('params.style_schema') !== 'lg-ais') {
        this.disable();
        // }
        this.controlText('Loading...');
        vjsSrv.vjsPlayer.PrevNextButtonSrv.handleClick(componentName, options);
      });
    },
  });
  videojs.registerComponent(componentName, newButton);
}

register('NextButton', {
  controlText: 'Next',
  elClass: 'vjs-play-next-btn',
  pmEvent: PLAYER_EVENTS.PLAYING_NEXT,
});
register('PrevButton', {
  controlText: 'Previous',
  elClass: 'vjs-play-prev-btn',
  pmEvent: PLAYER_EVENTS.PLAYING_PREV,
});

// export const PrevNextButtonSrv = _PrevNextButtonSrv;
